import { ResolveFn, Routes } from '@angular/router';
import UserRouteAccessService from 'app/core/auth/user-route-access-service';
import {
  Observable, of
} from 'rxjs';
import {
  CouponRx, ICouponRx
} from 'app/shared/model/coupon-rx.model';
import CouponRxComponent from './coupon-rx.component';
import ResolvePagingParams from '../resolve-paging-params.service';

export const CouponRxResolve: ResolveFn<ICouponRx> = (): Observable<ICouponRx> => of(new CouponRx());

export const couponRoute: Routes = [
  {
    path: '',
    component: CouponRxComponent,
    resolve: {
      pagingParams: ResolvePagingParams
    },
    data: {
      authorities: ['ROLE_USER'],
      defaultSort: 'id,asc',
      pageTitle: 'bjcrxApp.coupon.home.title'
    },
    canActivate: [UserRouteAccessService]
  }
];
